export function reportError(err, info, handler) {
  const message = err instanceof Error ? err.message : String(err);

  if (typeof window === 'undefined') {
    // eslint-disable-next-line no-console
    console.error('SSR error - reported via server logs only', err, {
      errorSource: info,
      handler: handler,
    });
    return;
  }

  // eslint-disable-next-line no-console
  console.error(message, { errorSource: info, handler: handler });

  if (typeof fetch !== 'function') {
    return;
  }

  fetch('/rendering/client-error', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      message,
      stack: err instanceof Error ? err.stack : undefined,
      errorSource: info,
      handler: handler,
    }),
  }).catch(() => {
    // swallow errors: error reporting must not break the app
  });
}

/* istanbul ignore next */
export function setupErrorHandling(Vue) {
  Vue.config.errorHandler = function(err, _vm, info) {
    reportError(err, info, 'errorHandler');
  };

  Vue.config.errorCaptured = function(err, _vm, info) {
    reportError(err, info, 'errorCaptured');
  };
}
